import { RECOGNITIONS_PAGE_LIMIT, listRecognitions } from './recognitions';
import { END_SESSION } from './session';
import { findObjById, replaceObjByObjId } from './utils';

const CLEAR_ERROR = 'RECOGNITION::CLEAR_ERROR';
const CLEAR_RECOGNITION = 'RECOGNITION::CLEAR_RECOGNITION';
const DELETE_RECOGNITION_REQUEST_SENT = 'RECOGNITION::DELETE_RECOGNITION_REQUEST_SENT';
export const DELETE_RECOGNITION_REQUEST_SUCCESS = 'RECOGNITION::DELETE_RECOGNITION_REQUEST_SUCCESS';
const DELETE_RECOGNITION_REQUEST_FAIL = 'RECOGNITION::DELETE_RECOGNITION_REQUEST_FAIL';
const GET_RECOGNITION_REQUEST_SENT = 'RECOGNITION::GET_RECOGNITION_REQUEST_SENT';
const GET_RECOGNITION_REQUEST_SUCCESS = 'RECOGNITION::GET_RECOGNITION_REQUEST_SUCCESS';
const GET_RECOGNITION_REQUEST_FAIL = 'RECOGNITION::GET_RECOGNITION_REQUEST_FAIL';
const GET_REMEETING_RECOGNITION_REQUEST_SENT = 'RECOGNITION::GET_REMEETING_RECOGNITION_REQUEST_SENT';
const GET_REMEETING_RECOGNITION_REQUEST_SUCCESS = 'RECOGNITION::GET_REMEETING_RECOGNITION_REQUEST_SUCCESS';
const GET_REMEETING_RECOGNITION_REQUEST_FAIL = 'RECOGNITION::GET_REMEETING_RECOGNITION_REQUEST_FAIL';
const POST_RECOGNITION_REQUEST_SENT = 'RECOGNITION::POST_RECOGNITION_REQUEST_SENT';
export const POST_RECOGNITION_REQUEST_SUCCESS = 'RECOGNITION::POST_RECOGNITION_REQUEST_SUCCESS';
const POST_RECOGNITION_REQUEST_FAIL = 'RECOGNITION::POST_RECOGNITION_REQUEST_FAIL';

/* These are the actions and reducer that handle the recognition slice of the global state */
const initialState = {
  deleteRecognitionRequestError: undefined,
  deleteRecognitionRequestOut: false,
  getRecognitionRequestError: undefined,
  getRecognitionRequestOut: false,
  getRemeetingRecognitionRequestError: undefined,
  getRemeetingRecognitionRequestOut: false,
  postRecognitionRequestError: undefined,
  postRecognitionRequestOut: false,
  recognition: {},
  remeetingRecognition: {},
  recognitionsCache: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_ERROR:
      return {
        ...state,
        deleteRecognitionRequestError: undefined,
        getRecognitionRequestError: undefined,
        postRecognitionRequestError: undefined,
      };
    case CLEAR_RECOGNITION:
      return {
        ...state,
        recognition: {},
      };
    case DELETE_RECOGNITION_REQUEST_SENT:
      return {
        ...state,
        deleteRecognitionRequestError: undefined,
        deleteRecognitionRequestOut: true,
      };
    case DELETE_RECOGNITION_REQUEST_SUCCESS:
      return {
        ...state,
        deleteRecognitionRequestOut: false,
        recognitionsCache: [...state.recognitionsCache.filter(recog => recog.id !== action.id)],
        recognition: {},
      };
    case DELETE_RECOGNITION_REQUEST_FAIL:
      return {
        ...state,
        deleteRecognitionRequestError: action.error,
        deleteRecognitionRequestOut: false,
      };
    case END_SESSION:
      return { ...initialState };
    case GET_RECOGNITION_REQUEST_SENT:
      return {
        ...state,
        recognition: findObjById(state.recognitionsCache, action.id),
        getRecognitionRequestOut: true,
        getRecognitionRequestError: undefined,
      };
    case GET_RECOGNITION_REQUEST_SUCCESS: {
      return {
        ...state,
        recognitionsCache: replaceObjByObjId(state.recognitionsCache, action.recognition),
        recognition: action.recognition,
        getRecognitionRequestOut: false,
      };
    }
    case GET_RECOGNITION_REQUEST_FAIL:
      return {
        ...state,
        getRecognitionRequestError: action.error,
        getRecognitionRequestOut: false,
      };
    case GET_REMEETING_RECOGNITION_REQUEST_SENT: {
      const rmtgRecognition = state.remeetingRecognition;
      return {
        ...state,
        remeetingRecognition: rmtgRecognition.id === action.id ? rmtgRecognition : {},
        getRemeetingRecognitionRequestOut: true,
        getRemeetingRecognitionRequestError: undefined,
      };
    }
    case GET_REMEETING_RECOGNITION_REQUEST_SUCCESS: {
      return {
        ...state,
        remeetingRecognition: action.recognition,
        getRemeetingRecognitionRequestOut: false,
      };
    }
    case GET_REMEETING_RECOGNITION_REQUEST_FAIL:
      return {
        ...state,
        getRemeetingRecognitionRequestError: action.error,
        getRemeetingRecognitionRequestOut: false,
      };
    case POST_RECOGNITION_REQUEST_SENT:
      return {
        ...state,
        postRecognitionRequestError: undefined,
        postRecognitionRequestOut: true,
      };
    case POST_RECOGNITION_REQUEST_SUCCESS:
      return {
        ...state,
        recognitionsCache: [...state.recognitionsCache.concat([action.recognition])],
        postRecognitionRequestOut: false,
      };
    case POST_RECOGNITION_REQUEST_FAIL:
      return {
        ...state,
        postRecognitionRequestError: action.error,
        postRecognitionRequestOut: false,
      };
    default:
      return state;
  }
};

export const clearError = () => ({
  type: CLEAR_ERROR,
});

export const deleteRecognition = id => (dispatch, getState) => {
  const { recognitions, rmi } = getState();

  dispatch({ type: DELETE_RECOGNITION_REQUEST_SENT });
  return rmi.recognitions.delete({ id })
    .then(() => {
      dispatch({ type: DELETE_RECOGNITION_REQUEST_SUCCESS, id });
      // SIDE EFFECT: update the recognitions list conditionally
      if (
        !recognitions.recognitionsLoaded
          && recognitions.recognitions.length <= RECOGNITIONS_PAGE_LIMIT
      ) {
        dispatch(listRecognitions());
      }
    })
    .catch((error) => {
      dispatch({ type: DELETE_RECOGNITION_REQUEST_FAIL, error });
    });
};

export const getRecognition = (id, format) => (dispatch, getState) => {
  const { rmi } = getState();
  const options = { id };

  if (format) {
    options.format = format;
  }

  dispatch({ type: GET_RECOGNITION_REQUEST_SENT, id });
  return rmi.recognitions.get(options)
    .then((recognition) => {
      dispatch({ type: GET_RECOGNITION_REQUEST_SUCCESS, recognition });
    })
    .catch((error) => {
      dispatch({ type: GET_RECOGNITION_REQUEST_FAIL, error });
    });
};

export const getRemeetingRecognition = id => (dispatch, getState) => {
  const { rmi } = getState();
  const options = { id, format: 'remeeting' };

  dispatch({ type: GET_REMEETING_RECOGNITION_REQUEST_SENT, id });
  return rmi.recognitions.get(options)
    .then((recognition) => {
      dispatch({ type: GET_REMEETING_RECOGNITION_REQUEST_SUCCESS, recognition });
    })
    .catch((error) => {
      dispatch({ type: GET_REMEETING_RECOGNITION_REQUEST_FAIL, error });
    });
};

export const postRecognition = config => (dispatch, getState) => {
  const { rmi } = getState();

  dispatch({ type: POST_RECOGNITION_REQUEST_SENT });
  return rmi.recognitions.post(config)
    .then((recognition) => {
      dispatch({ type: POST_RECOGNITION_REQUEST_SUCCESS, recognition });
    })
    .catch((error) => {
      dispatch({ type: POST_RECOGNITION_REQUEST_FAIL, error });
    });
};
